// extracted by mini-css-extract-plugin
export default {"root":"style-module__root___JFhRt","root__img":"style-module__root__img___XBv3r","root__btn":"style-module__root__btn___zdBwG","root__icon":"style-module__root__icon___aeaJp"};
    if(module.hot) {
      // 1729151132167
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  